import { connect } from 'react-redux'
import {
  fetchMembers,
  deleteMember,
  modifyMember,
  signOut,
  addMember,
  addUser,
  deleteUser,
  fetchUsers
} from '../actions'
import Directory from '../components/directory'

const mapStateToProps = state => {
  return {
    members: state.members,
    isLoading: state.isLoading,
    users: state.users,
    addUserSuccess: state.addUserSuccess
  }
}

const mapDispatchToProps = dispatch => {
  return {
    fetchMembers: cb => dispatch(fetchMembers(cb)),
    deleteMember: id => dispatch(deleteMember(id)),
    modifyMember: (id, member, prevMember) =>
      dispatch(modifyMember(id, member, prevMember)),
    addMember: member => dispatch(addMember(member)),
    addUser: (email, cb) => dispatch(addUser(email, cb)),
    deleteUser: userId => dispatch(deleteUser(userId)),
    fetchUsers: () => dispatch(fetchUsers()),
    signOut: () => dispatch(signOut())
  }
}

const DirectoryContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(Directory)

export default DirectoryContainer



// WEBPACK FOOTER //
// ./src/containers/directoryContainer.js